import React from "react";
import injectSheet from "react-jss";
import clsx from "clsx";

class Input extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selStart: false,
      selEnd: false,
    };
    this.inputRef = React.createRef();
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }
  handleKeyUp(e) {
    if (e.keyCode === 37 || e.keyCode === 39) {
      return;
    }
    if (this.state.selStart !== false && this.state.selEnd !== false) {
      this.inputRef.current.setSelectionRange(
        this.state.selStart,
        this.state.selEnd,
      );
    }
  }
  render() {
    const {
      classes,
      placeholder,
      type = "text",
      value,
      onChange,
      name,
      formattingMethod,
    } = this.props;

    if (this.state.selStart !== false && this.state.selEnd !== false) {
      //this.inputRef.current.setSelectionRange(this.state.selStart, this.state.selEnd);
    }
    return (
      <input
        name={name}
        className={clsx(classes.input, {
          [classes.capital]: formattingMethod,
        })}
        placeholder={placeholder}
        type={type}
        value={value}
        ref={this.inputRef}
        onKeyUp={this.handleKeyUp}
        onChange={e => {
          let start = e.target.selectionStart;
          let end = e.target.selectionEnd;
          this.setState({ selStart: start, selEnd: end });
          onChange(e.target.value);
        }}
      />
    );
  }
}

const styles = theme => ({
  input: {
    border: 0,
    borderRadius: theme.borderRadius,
    backgroundColor: theme.colorDarkGrey,
    padding: 10,
    width: "100%",
    maxWidth: 300,
    boxSizing: "border-box",
    margin: "10px 0",
    color: theme.textColor,
  },
  capital: {},
});

export default injectSheet(styles)(Input);
